import React, { Component } from 'react';
import { TabBar } from 'antd-mobile';
import Home from './Home/index';
import My from './My/index';
import * as util from '../util/util';
import store from 'store'

class TabPage extends Component {

  constructor(props) {
    super(props)
    this.param = util.parseSearchToState(this.props.history.location.search)
    this.state = {
      hidden: false,
      fullScreen: true,
      selectedTab: 'home'
    }
  }
  componentDidMount() {
    // 页面跳转
    if (this.param.page) {
      window.history.pushState({status: 0} ,'' ,'?a=1')
      this.props.history.push(`/${this.param.page}${util.parseStateToSearch(this.param)}`)
    }
    // 添加合作渠道
    if (this.param.channel) {
      store.set('channel', this.param.channel)
    }
  }
  componentWillReceiveProps(props){
    if (this.props.history.location.query && this.props.history.location.query.type === 'CouponInstructions') {
      this.setState({
        selectedTab: 'home',
      });
      this.props.history.location.query.type = ''
    }
  }
  render() {
    return <div style={{position: 'absolute', height: '100%', width: '100%', top: 0 }}>
      <TabBar
        unselectedTintColor="#949494"
        prerenderingSiblingsNumber={0}
        tintColor="#c73420"
        barTintColor="white"
        hidden={this.state.hidden}>
        <TabBar.Item
          title="首页"
          key="home"
          icon={<div style={{
            width: '22px',
            height: '22px',
            background: 'url(/assets/car.png) center center /  21px 21px no-repeat'
          }}
          />
          }
          selectedIcon={<div style={{
            width: '22px',
            height: '22px',
            background: 'url(/assets/car-select.png) center center /  21px 21px no-repeat'
          }}
          />
          }
          selected={this.state.selectedTab === 'home'}
          badge={0}
          onPress={() => {
            this.setState({
              selectedTab: 'home',
            });
          }}
        >
         <Home {...this.props}/>
        </TabBar.Item>
        <TabBar.Item
          title="我的"
          key="my"
          icon={<div style={{
            width: '22px',
            height: '22px',
            background: 'url(/assets/user.png) center center /  21px 21px no-repeat'
          }}
          />
          }
          selectedIcon={<div style={{
            width: '22px',
            height: '22px',
            background: 'url(/assets/user-select.png) center center /  21px 21px no-repeat'
          }}
          />
          }
          selected={this.state.selectedTab === 'my'}
          badge={0}
          onPress={() => {
            this.setState({
              selectedTab: 'my',
            });
            this.refs.childMy && this.refs.childMy.init()
          }}
        >
         <My {...this.props} ref="childMy"/>
        </TabBar.Item>
      </TabBar>
    </div>
  }
}

export default TabPage